import React, { useState } from "react";
import styles from "./CreateOrder.module.css";
import HeadingComponent from "../../../../../components/HeadingComponent/HeadingComponent";
import {
  InputField,
  SubmitButton,
  TextComponent,
  Dropdown,
  Modal,
  DateInput,
} from "../../../../../components";
import { FiSearch } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { VscDiffAdded } from "react-icons/vsc";
import { IoCloseCircleOutline } from "react-icons/io5";
import CheckBox from "../../../../../components/Checkbox/CheckBox";
import { List } from "antd";
import Switch from "../../../../../components/Switch/Switch";
import { Modal as ModalTopTab } from "antd";
import TopTab from "../../../../../components/TopTab/TopTab";
import { t } from "i18next";
import { MdOutlineDateRange } from "react-icons/md";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";

const CreateOrder = () => {
  const [OrderValue, setOrderValue] = useState("");
  const [OrderArray, setOrderArray] = useState([]);
  const [OrderCost, setOrderCost] = useState("");
  const [EstimatedTime, setEstimatedTime] = useState("");
  const [OrderBy, setOrderBy] = useState("");
  const [MachineCategory, setMachineCategory] = useState("");
  const [MachineType, setMachineType] = useState("");
  const [MinimumWeightCapacity, setMinimumWeightCapacity] = useState("");
  const [MaximumWeightCapacity, setMaximumWeightCapacity] = useState("");
  const [isChecked, setIsChecked] = useState(true);
  const [OrderSource, setOrderSource] = useState({
    value: "WalkIn",
    role: "WalkIn",
    id: 1,
  });
  const [MachineName, setMachineName] = useState({
    value: "Stand Mixer",
    role: "Stand Mixer",
    id: 1,
  });
  const [LimitExceedsModal, setLimitExceedsModal] = useState(false);
  const [CancelModal, setCancelModal] = useState(false);

  const [ReplaceEquipmentModal, setReplaceEquipmentModal] = useState(false);

  const [AddEquipmentModal, setAddEquipmentModal] = useState(false);
  const options = [
    { id: 1, name: "New Equipment" },
    { id: 2, name: "Current Equipment" },
  ];
  const [focused, setFocused] = useState(options[0]);

  const handleAddProduct = () => {
    if (OrderValue.trim() !== "") {
      setOrderArray((prev) => [...prev, { name: OrderValue, ItemQuantity: 1 }]);
      setOrderValue("");
    }
  };

  const handleRemoveProduct = (item) => {
    setOrderArray(OrderArray.filter((element) => element?.name !== item?.name));
    console.log("removed");
  };

  const handleAddQuantity = (item) => {
    setOrderArray((prevArray) =>
      prevArray.map((element, index) =>
        element.name == item?.name
          ? { ...element, ItemQuantity: element?.ItemQuantity + 1 }
          : element
      )
    );
  };
  const handleDeleteQuantity = (item) => {
    setOrderArray((prevArray) =>
      prevArray.map((element) =>
        element.name == item?.name && element?.ItemQuantity > 1
          ? { ...element, ItemQuantity: element?.ItemQuantity - 1 }
          : element
      )
    );
  };

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  const renderOverview = (item, index) => {
    return (
      <div className={styles.ProductContainer}>
        <div className={styles.row}>
          <HeadingComponent
            fontSize={"var(--mobile-subheading)"}
            text={`Product ${index + 1}`}
            padding={"0px"}
          />
          <IoCloseCircleOutline
            cursor={"pointer"}
            onClick={() => handleRemoveProduct(item)}
          />
        </div>
        <div className={styles.Box}>
          <div className={styles.row}>
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <FiSearch color={"#808080"} />

              <TextComponent
                text={item?.name}
                fontFamily={"Poppins-regular"}
                color={"#808080"}
              />
            </div>
            <div className={styles.CounterDiv}>
              <RiDeleteBin6Line
                cursor={"pointer"}
                onClick={() => handleDeleteQuantity(item)}
              />

              <TextComponent
                text={item?.ItemQuantity}
                color={"#808080"}
                padding={"0px"}
              />
              <VscDiffAdded
                cursor={"pointer"}
                onClick={() => handleAddQuantity(item)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  console.log(" isChecked -->", isChecked);

  return (
    <div className={styles.mainCont}>
      <HeaderComponent showBackIcon={true} heading={t("Create Order")} />
      <div className={styles.subCont}>
        <div className={styles.leftCont}>
          <div className={styles.SubleftCont}>
            <InputField
              className={styles.input}
              placeholder={"Enter Product Name"}
              LabelColor={"#808080"}
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              innerInput={{ backgroundColor: "#F7F8F9" }}
              placeholderTextColor={"#808080"}
              value={OrderValue}
              onChange={(e) => setOrderValue(e.target.value)}
              leftIcon={<FiSearch size={20} color={"var(--input-icon)"} />}
              // onRightIconPress={() => setPasswordVisible(!passwordVisible)}
            />
            <div className={styles.InputDiv}>
              <List
                dataSource={OrderArray}
                renderItem={renderOverview}
                style={{ marginTop: 10 }}
                grid={{
                  xs: 1,
                  sm: 1,
                  md: 1,
                  lg: 1,
                  xl: 1,
                  xxl: 1,
                }}
              />
            </div>
          </div>
          <SubmitButton
            title={"Add Product"}
            onClick={handleAddProduct}
            btnClass={styles.AddProductButton}
            btnContainerClass={styles.AddProductButtonContainerClass}
            secondary
          />
        </div>

        <div className={styles.rightCont}>
          <div className={styles.SubrightCont}>
            <div className={styles.TwoInputsDivs}>
              <InputField
                labelClass={styles.label}
                inputStyle={{
                  backgroundColor: "#F7F8F9",
                  border: "1.5px solid #E8ECF4",
                }}
                innerInput={{ backgroundColor: "#F7F8F9" }}
                label="Cost of Order"
                placeholder={"$504"}
                className={styles.inputStyle}
                value={OrderCost}
                onChange={(e) => setOrderCost(e.target.value)}
                type={"number"}
              />

              <InputField
                labelClass={styles.label}
                inputStyle={{
                  backgroundColor: "#F7F8F9",
                  border: "1.5px solid #E8ECF4",
                }}
                innerInput={{ backgroundColor: "#F7F8F9" }}
                className={styles.inputStyle}
                placeholder={"180 minutes"}
                label="Estimated Time of Completion"
                value={EstimatedTime}
                onChange={(e) => setEstimatedTime(e.target.value)}
              />
            </div>
            <div className={styles.Col}>
              <div className={styles.TwoInputsDivs}>
                <TextComponent
                  padding={"0px"}
                  text={"Order By"}
                  fontFamily={"Inter-semibold"}
                />

                <CheckBox onClick={onChange}>Mark as Production Order</CheckBox>
              </div>
              <InputField
                leftIcon={<FiSearch size={20} />}
                className={styles.inputStyle}
                placeholder={"John Smith"}
                value={OrderBy}
                onChange={(e) => setOrderBy(e.target.value)}
                inputStyle={{
                  backgroundColor: "#F7F8F9",
                  border: "1.5px solid #E8ECF4",
                  marginTop: "0px",
                }}
                innerInput={{ backgroundColor: "#F7F8F9" }}
              />
            </div>

            <Dropdown
              label={"Order Source"}
              labelClass={styles.DropDownLabel}
              value={OrderSource}
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              inputClass={styles.DropdownInput}
              style={{ color: "var(--black-color)" }}
              options={[
                {
                  value: "WalkIn",
                  role: "WalkIn",
                  id: 1,
                },
                {
                  value: "Call",
                  role: "Call",
                  id: 2,
                },
                {
                  value: "Text/WhatsApp",
                  role: "Text/WhatsApp",
                  id: 3,
                },
                {
                  value: "Standing",
                  role: "Standing",
                  id: 3,
                },
              ]}
              onChange={(e) => setOrderSource(e)}
            />
            <div className={styles.SecondRow}>
              <TextComponent
                padding={"0px"}
                text={"Scheduling"}
                fontFamily={"Inter-semibold"}
              />
                 <Switch
                  SwitchLabelStyle={styles.SwitchLabelStyle}
                  label={
                    isChecked ? "Forward Scheduling" : "Backward Scheduling"
                  }
                  SwitchContainerStyle={styles.SwitchContainerStyle}
                  isChecked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                  size="small"
                  inactiveColor={"var(--switch-Inactive-color)"}
                  activeColor={"var(--switch-active-color)"}
                />
             </div>

            {/* <div className={styles.TwoInputsDivs}>
              <InputField
                labelClass={styles.label}
                inputStyle={{
                  backgroundColor: "#F7F8F9",
                  border: "1.5px solid #E8ECF4",
                }}
                innerInput={{ backgroundColor: "#F7F8F9" }}
                label="Cost of Order"
                placeholder={"$504"}
                className={styles.inputStyle}
                value={OrderCost}
                onChange={(e) => setOrderCost(e.target.value)}
              />

              <InputField
                labelClass={styles.label}
                inputStyle={{
                  backgroundColor: "#F7F8F9",
                  border: "1.5px solid #E8ECF4",
                }}
                innerInput={{ backgroundColor: "#F7F8F9" }}
                className={styles.inputStyle}
                placeholder={"180 minutes"}
                label="Estimated Time of Completion"
                value={EstimatedTime}
                onChange={(e) => setEstimatedTime(e.target.value)}
              />
            </div> */}
            <div className={styles.DateDiv}>
              <DateInput
                className={styles.DateInput}
                label={"Start Production Date and Time"}
                placeholder={"Aug 25, 2025 12:14 pm"}
                rightIcon={<MdOutlineDateRange />}
              />
              <DateInput
                className={styles.DateInput}
                label={"Due Date"}
                placeholder={"Aug 25, 2025 12:14 pm"}
                rightIcon={<MdOutlineDateRange />}
              />
            </div>
            <InputField
              label={"Internal Notes"}
              labelClass={styles.label}
              placeholder={"Optional Internal Notes"}
              value={OrderBy}
              onChange={(e) => setOrderBy(e.target.value)}
              inputStyle={{
                backgroundColor: "#F7F8F9",
                border: "1.5px solid #E8ECF4",
              }}
              innerInput={{ backgroundColor: "#F7F8F9" }}
            />
          </div>
          <SubmitButton
            title={"Create Order"}
            onClick={() => setLimitExceedsModal(true)}
            btnClass={styles.AddProductButton}
            btnContainerClass={styles.AddProductButtonContainerClass}
            primary
          />
        </div>
      </div>

      <Modal
        open={LimitExceedsModal}
        onCancel={() => {
          setLimitExceedsModal(false);
          // setCancelModal(true);
        }}
        onClickOkButton={() => {
          setLimitExceedsModal(false);
          setReplaceEquipmentModal(true);
        }}
        title={"Batch Weight Does Not Match Machine Limit"}
        className={styles.Modal}
        // width={"90%"}
        twoButton
        okBtnTitle={"Replace Equipment"}
        cancelBtnTitle={"Add  Equipment"}
        onClickCancelButton={() => {
          setLimitExceedsModal(false);
          setAddEquipmentModal(true);
        }}
        onBtnPress={() => setLimitExceedsModal(false)}
      >
        <TextComponent
          textAlign={"center"}
          text="The batch weight (120kg) exceeds the maximum limit of the selected Mixer (100kg). Please change or add a machine to continue."
        />
      </Modal>

      {/* ============ ReplaceEquipmentModal ===================== */}

      <Modal
        open={ReplaceEquipmentModal}
        onCancel={() => setReplaceEquipmentModal(false)}
        SingleButtonClass
        className={styles.Modal}
        onClickOkButton={() => setReplaceEquipmentModal(false)}
        // width={"90%"}
        title={"Replace Equipment"}
        buttonTitle={"Confirm"}
        onBtnPress={() => setReplaceEquipmentModal(false)}
      >
        <Dropdown
          label={"Machine Name"}
          labelClass={styles.DropDownLabel}
          value={MachineName}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Stand Mixer",
              role: "Stand Mixer",
              id: 1,
            },
            {
              value: "Blender",
              role: "Blender",
              id: 2,
            },
          ]}
          onChange={(e) => setMachineName(e)}
        />
        <div className={styles.ModalTwoInputs}>
          <InputField
            labelClass={styles.label}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            label="Machine Category"
            placeholder={"$504"}
            className={styles.ModalinputStyle}
            value={MachineCategory}
            onChange={(e) => setMachineCategory(e.target.value)}
          />

          <InputField
            labelClass={styles.label}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.ModalinputStyle}
            placeholder={"180 minutes"}
            label="Machine Type"
            value={MachineType}
            onChange={(e) => setMachineType(e.target.value)}
          />
        </div>
        <div className={styles.ModalTwoInputs}>
          <InputField
            labelClass={styles.label}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            label="Minimum Weight Capacity"
            placeholder={"200"}
            className={styles.ModalinputStyle}
            value={MinimumWeightCapacity}
            onChange={(e) => setMinimumWeightCapacity(e.target.value)}
            rightIcon={<TextComponent textAlign={"center"} text="Ibs" />}
            type={"number"}
          />

          <InputField
            labelClass={styles.label}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.ModalinputStyle}
            placeholder={"200 "}
            label="Maximum Weight Capacity"
            value={MaximumWeightCapacity}
            onChange={(e) => setMaximumWeightCapacity(e.target.value)}
            rightIcon={<TextComponent textAlign={"center"} text="Ibs" />}
            type={"number"}
          />
        </div>
      </Modal>

      {/* ============ CancelModal ===================== */}

      <Modal
        open={CancelModal}
        onCancel={() => {
          setCancelModal(false);
        }}
        onClickOkButton={() => {
          setCancelModal(false);
        }}
        className={styles.Modal}
        // width={"90%"}
        twoButton
        buttonTitle={"Cancel Order"}
        onBtnPress={() => setCancelModal(false)}
      >
        <HeadingComponent
          text={"Cancel Order?"}
          fontSize={20}
          textAlign={"center"}
        />

        <TextComponent
          textAlign={"center"}
          text="Are you sure you want to cancel this order? This action cannot be undone."
        />
      </Modal>

      {/* ============ AddEquipmentModal ===================== */}

      <Modal
        open={AddEquipmentModal}
        onCancel={() => setAddEquipmentModal(false)}
        className={`${styles.modalCont}`}
        footer={false}
        title={"Add Equipment"}
      >
        <TopTab
          options={options}
          focused={focused}
          setFocused={setFocused}
          TabStyle={styles.TabStyle}
          TopTabListStyle={styles.TopTabListStyle}
          TabLabelColor={"--var(--white-color)"}
        />

        <Dropdown
          label={"Machine Name"}
          labelClass={styles.DropDownLabel}
          value={MachineName}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Stand Mixer",
              role: "Stand Mixer",
              id: 1,
            },
            {
              value: "Blender",
              role: "Blender",
              id: 2,
            },
          ]}
          onChange={(e) => setMachineName(e)}
        />

        <div className={styles.ModalTwoInputs}>
          <InputField
            labelClass={styles.label}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            label="Machine Category"
            placeholder={"Oven"}
            className={styles.ModalinputStyle}
            value={MachineCategory}
            onChange={(e) => setMachineCategory(e.target.value)}
          />

          <InputField
            labelClass={styles.label}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.ModalinputStyle}
            placeholder={"Manual"}
            label="Machine Type"
            value={MachineType}
            onChange={(e) => setMachineType(e.target.value)}
          />
        </div>

        <div className={styles.ModalTwoInputs}>
          <InputField
            labelClass={styles.label}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            label="Minimum Weight Capacity"
            placeholder={"200"}
            className={styles.ModalinputStyle}
            value={MinimumWeightCapacity}
            onChange={(e) => setMinimumWeightCapacity(e.target.value)}
            rightIcon={<TextComponent textAlign={"center"} text="Ibs" />}
            type={"number"}
          />

          <InputField
            labelClass={styles.label}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.ModalinputStyle}
            placeholder={"200 "}
            label="Maximum Weight Capacity"
            value={MaximumWeightCapacity}
            onChange={(e) => setMaximumWeightCapacity(e.target.value)}
            rightIcon={<TextComponent textAlign={"center"} text="Ibs" />}
            type={"number"}
          />
        </div>
        {focused?.name === "New Equipment" && (
          <SubmitButton
            primary
            title={"Confirm"}
            onClick={() => setAddEquipmentModal(false)}
            style={{ width: "100%", marginTop: "20px" }}
          />
        )}
      </Modal>
    </div>
  );
};

export default CreateOrder;
